import type {
	SketchEntityReferenceRepository,
	SketchEntityReferenceRepositoryWriteScope,
} from '../repository/SketchEntityReferenceRepository';

/**
 * 在正式仓储或上层已经打开的工作副本中执行引用写入。
 *
 * 上层事务传入工作副本时禁止再次嵌套仓储事务，但仍必须在工作前后校验 checkpoint
 * 所有权；普通入口传入正式仓储时则由仓储创建唯一写事务。
 *
 * @param formalRepository 当前文档正式仓储。
 * @param repository 当前调用拿到的正式仓储或上层工作副本。
 * @param isInputCurrent checkpoint 所有权校验。
 * @param staleError 所有权失效时抛出的领域信号。
 * @param work 仓储写入工作。
 * @returns 写入工作的返回值。
 */
export async function executeSketchEntityReferenceRepositoryWrite<T>(
	formalRepository: SketchEntityReferenceRepository,
	repository: SketchEntityReferenceRepositoryWriteScope,
	isInputCurrent: () => boolean,
	staleError: unknown,
	work: (tx: SketchEntityReferenceRepositoryWriteScope) => Promise<T>,
): Promise<T> {
	if (repository === formalRepository) {
		return formalRepository.withWriteTransaction(
			work,
			isInputCurrent,
		);
	}
	if (!isInputCurrent()) {
		throw staleError;
	}
	const result = await work(repository);
	if (!isInputCurrent()) {
		throw staleError;
	}
	return result;
}
